import {MarkGithubIcon} from '@primer/octicons-react'

import {logoAnalyticsEvent} from '../header-analytics'
import styles from './HeaderLogo.module.css'

type HeaderLogoProps = {
  /** SSR'd homepage href (`home_path`); Rails resolves `logged_in? ? "/home" : "/"`. */
  href: string

  /** While the mobile menu is open, drop the logo from the tab order so focus stays trapped in the menu. */
  isMenuOpen: boolean
}

/**
 * GitHub logo linking to the homepage. Sits between the mobile menu toggle and the mobile auth CTAs in
 * the top row, centered on mobile and left-aligned from `lg`.
 */
export function HeaderLogo({href, isMenuOpen}: HeaderLogoProps) {
  return (
    <a
      href={href}
      aria-label="Homepage"
      className={styles.logo}
      tabIndex={isMenuOpen ? -1 : undefined}
      {...logoAnalyticsEvent}
    >
      <MarkGithubIcon size={32} />
    </a>
  )
}
